import InvoiceFilters from "./InvoiceFilters";
import InvoiceTable from "./InvoiceTable";
import InvoicePagination from "./InvoicePagination";
import AnularInvoiceModal from "./modals/AnularInvoiceModal";
import InvalidacionModal from "./modals/InvalidacionModal";
import ReprintModal from "./modals/ReprintModal";
import { useInvoices } from "../../hooks/useInvoices";
import { useInvoiceAnulacion } from "../../hooks/useInvoiceAnulacion";
import { useInvalidacion } from "../../hooks/useInvalidacion";
import { useReprint } from "../../hooks/useReprint";
import { exportConsumidorResumen } from "../../components/utils/invoiceExportConsumidorResumen";
import { exportConsumidorDetallado } from "../../components/utils/invoiceExportConsumidorDetallado";
import { exportCreditoDetallado } from "../../components/utils/invoiceExportCreditoDetallado";
import { exportAnexosConsumidor } from "../../components/utils/invoiceExportAnexosConsumidor";
import { exportAnexosContribuyente } from "../../components/utils/invoiceExportAnexosContribuyente";
import { exportAnexosAnuladas } from "../../components/utils/invoiceExportAnexosAnuladas";
import { descargarJsonsZip } from "../../components/utils/invoiceExportJsonZip";
import { validarRangoFechas } from "../../components/utils/invoiceValidation";

import Swal from "sweetalert2";
import "./Invoicelist.css";

export default function InvoiceList() {
  const {
    invoices,
    loading,
    fromDate,
    toDate,
    tipoFiltro,
    currentPage,
    totalPages,
    total,
    from,
    to,
    setFromDate,
    setToDate,
    fetchInvoices,
    handlePageChange,
    handleClearFilters,
    handleTipoFiltro,
  } = useInvoices();

  const {
    showAnularModal,
    selectedInvoice: invoiceToAnular,
    motivoAnulacion,
    isAnulando,
    setMotivoAnulacion,
    handleOpenAnularModal,
    handleCloseAnularModal,
    handleAnularFactura
  } = useInvoiceAnulacion(() => fetchInvoices(currentPage));

  const {
    showInvalidacionModal,
    selectedInvoice: invoiceToView,
    selectedInvalidacion,
    loadingInvalidacion,
    isDownloading,
    handleVerInvalidacion,
    handleCloseInvalidacionModal,
    handleDescargarInvalidacion
  } = useInvalidacion();

  const {
    showReprintModal,
    saleToReprint,
    handleOpenReprint,
    handleCloseReprint,
  } = useReprint();

  const handleSearch = () => {
    const validacion = validarRangoFechas(fromDate, toDate);
    if (!validacion.valido) {
      return Swal.fire("Atención", validacion.mensaje, "warning");
    }
    fetchInvoices(1);
  };

  const handleDescargarOpciones = async () => {
    if (!fromDate || !toDate) {
      return Swal.fire("Atención", "Debes seleccionar un rango de fechas primero", "warning");
    }

    await Swal.fire({
      title: "📥 Selecciona qué descargar",
      html: `
        <div style="text-align: left; font-family: sans-serif;">

          <div style="display: flex; gap: 16px; margin-bottom: 16px;">

            <!-- CONSUMIDOR FINAL -->
            <div style="flex: 1;">
              <p style="font-weight: bold; color: #2d3748; background: #ebf8ff; padding: 8px 10px; border-radius: 6px; margin-bottom: 10px; font-size: 13px;">
                📄 CONSUMIDOR FINAL
              </p>
              <button id="btn-cf-resumen" style="width:100%; margin-bottom: 6px; padding: 10px 12px; border: 2px solid #e2e8f0; border-radius: 8px; background: #fff; cursor: pointer; text-align: left; font-size: 13px;">
                📊 <strong>Excel Resumen</strong><br>
                <small style="color:#718096;">Agrupado por día</small>
              </button>
              <button id="btn-cf-detallado" style="width:100%; margin-bottom: 6px; padding: 10px 12px; border: 2px solid #e2e8f0; border-radius: 8px; background: #fff; cursor: pointer; text-align: left; font-size: 13px;">
                📋 <strong>Excel Detallado</strong><br>
                <small style="color:#718096;">Una fila por factura</small>
              </button>
              <button id="btn-cf-csv" style="width:100%; padding: 10px 12px; border: 2px solid #e2e8f0; border-radius: 8px; background: #fff; cursor: pointer; text-align: left; font-size: 13px;">
                📄 <strong>CSV Hacienda</strong><br>
                <small style="color:#718096;">Formato F07 - CF</small>
              </button>
            </div>

            <!-- CRÉDITO FISCAL -->
            <div style="flex: 1;">
              <p style="font-weight: bold; color: #2d3748; background: #f0fff4; padding: 8px 10px; border-radius: 6px; margin-bottom: 10px; font-size: 13px;">
                🧾 CRÉDITO FISCAL
              </p>
              <button id="btn-ccf-detallado" style="width:100%; margin-bottom: 6px; padding: 10px 12px; border: 2px solid #e2e8f0; border-radius: 8px; background: #fff; cursor: pointer; text-align: left; font-size: 13px;">
                📋 <strong>Excel Detallado</strong><br>
                <small style="color:#718096;">Una fila por factura</small>
              </button>
              <button id="btn-ccf-csv" style="width:100%; padding: 10px 12px; border: 2px solid #e2e8f0; border-radius: 8px; background: #fff; cursor: pointer; text-align: left; font-size: 13px;">
                📄 <strong>CSV Hacienda</strong><br>
                <small style="color:#718096;">Formato F07 - CCF</small>
              </button>
            </div>

          </div>

          <!-- ANULADAS -->
          <div style="border-top: 2px solid #e2e8f0; padding-top: 12px;">
            <p style="font-weight: bold; color: #2d3748; background: #fff5f5; padding: 8px 10px; border-radius: 6px; margin-bottom: 10px; font-size: 13px;">
              ❌ DOCUMENTOS ANULADOS
            </p>
            <button id="btn-anuladas-csv" style="width:100%; padding: 10px 12px; border: 2px solid #e2e8f0; border-radius: 8px; background: #fff; cursor: pointer; text-align: left; font-size: 13px;">
              📄 <strong>CSV Hacienda Anuladas</strong><br>
              <small style="color:#718096;">Formato F07 - Documentos anulados</small>
            </button>
          </div>

          <p style="margin-top: 12px; color: #718096; font-size: 12px; text-align: center;">
            📅 Período: <strong>${fromDate} al ${toDate}</strong>
          </p>
        </div>
      `,
      showConfirmButton: false,
      showCloseButton: true,
      width: 600,
      didOpen: () => {
        const btns = ['btn-cf-resumen', 'btn-cf-detallado', 'btn-cf-csv', 'btn-ccf-detallado', 'btn-ccf-csv', 'btn-anuladas-csv'];
        btns.forEach(id => {
          const btn = document.getElementById(id);
          if (btn) {
            btn.addEventListener('mouseenter', () => btn.style.borderColor = '#667eea');
            btn.addEventListener('mouseleave', () => btn.style.borderColor = '#e2e8f0');
          }
        });

        document.getElementById('btn-cf-resumen')?.addEventListener('click', () => { Swal.close(); setTimeout(() => exportConsumidorResumen(fromDate, toDate), 300); });
        document.getElementById('btn-cf-detallado')?.addEventListener('click', () => { Swal.close(); setTimeout(() => exportConsumidorDetallado(fromDate, toDate), 300); });
        document.getElementById('btn-cf-csv')?.addEventListener('click', () => { Swal.close(); setTimeout(() => exportAnexosConsumidor(fromDate, toDate), 300); });
        document.getElementById('btn-ccf-detallado')?.addEventListener('click', () => { Swal.close(); setTimeout(() => exportCreditoDetallado(fromDate, toDate), 300); });
        document.getElementById('btn-ccf-csv')?.addEventListener('click', () => { Swal.close(); setTimeout(() => exportAnexosContribuyente(fromDate, toDate), 300); });
        document.getElementById('btn-anuladas-csv')?.addEventListener('click', () => { Swal.close(); setTimeout(() => exportAnexosAnuladas(fromDate, toDate), 300); });
      }
    });
  };

  return (
    <div className="invoice-list-container">
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">📄 Facturas (DTE)</h2>
          
          <div className="d-flex gap-2">
            <button 
              className="btn btn-primary"
              onClick={handleDescargarOpciones}
              disabled={!fromDate || !toDate}
              title="Opciones de descarga"
            >
              📥 Descargar
            </button>

            <button 
              className="btn btn-secondary"
              onClick={() => descargarJsonsZip(fromDate, toDate)}
              disabled={!fromDate || !toDate}
              title="Descarga los JSONs del período en un archivo ZIP"
            >
              📦 Descargar JSONs ZIP
            </button>
          </div>
        </div>

        <div className="card-body">
          <InvoiceFilters
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            onSearch={handleSearch}
            onClear={handleClearFilters}
            tipoFiltro={tipoFiltro}
            onTipoFiltro={handleTipoFiltro}
          />

          <div className="results-info">
            <p>
              Mostrando <strong>{from} - {to}</strong> de <strong>{total}</strong> facturas
            </p>
          </div>

          <InvoiceTable
            invoices={invoices}
            loading={loading}
            onAnular={handleOpenAnularModal}
            onVerInvalidacion={handleVerInvalidacion}
            onClearFilters={handleClearFilters}
            hasFilters={!!(fromDate || toDate)}
            onReprint={handleOpenReprint}
          />

          {!loading && (
            <InvoicePagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>

      <AnularInvoiceModal
        show={showAnularModal}
        invoice={invoiceToAnular}
        motivo={motivoAnulacion}
        isAnulando={isAnulando}
        onMotivoChange={setMotivoAnulacion}
        onAnular={handleAnularFactura}
        onClose={handleCloseAnularModal}
      />

      <InvalidacionModal
        show={showInvalidacionModal}
        invoice={invoiceToView}
        invalidacion={selectedInvalidacion}
        loading={loadingInvalidacion}
        onDescargar={handleDescargarInvalidacion}
        isDownloading={isDownloading}
        onClose={handleCloseInvalidacionModal}
      />

      <ReprintModal
        show={showReprintModal}
        sale={saleToReprint}
        onClose={handleCloseReprint}
      />
    </div>
  );
}